import { Globe, MapPin, Film, Atom } from "lucide-react";

export const TOPIC_ICONS = {
  globe:     Globe,
  "map-pin": MapPin,
  film:      Film,
  atom:      Atom,
};
